import en from './en.yaml';
import pt from './pt.yaml';

const lang = $state<{ current: 'en' | 'pt' }>({ current: 'en' });
const copy = $derived(lang.current === 'en' ? en : pt);
const getCopy = () => copy;

export { lang, getCopy };
